var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.BModal, {
    attrs: {
      size: "lg",
      title: "Email change",
      "modal-class": "vue-need-bootstrap",
      lazy: "",
      centered: "",
      "hide-footer": "",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ cancel, ok }) {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_setup.emailChanged,
                    expression: "!emailChanged",
                  },
                ],
              },
              [
                _c(
                  "b-form-group",
                  {
                    staticClass: "my-3",
                    attrs: {
                      id: "current-email-input",
                      "label-cols": "3",
                      "content-cols": "9",
                      label: "Current email",
                      "label-for": "current-email-input",
                    },
                  },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "current-email-input",
                        type: "email",
                        disabled: "",
                      },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-form-text",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _setup.pendingEmail,
                            expression: "pendingEmail",
                          },
                        ],
                      },
                      [
                        _c("i", { staticClass: "fa fa-info-circle mr-1" }),
                        _vm._v(
                          "You have a pending confirmation for\n                    "
                        ),
                        _c("b", [_vm._v(_vm._s(_setup.pendingEmail))]),
                        _vm._v("."),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(_setup.ValidationObserver, {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ handleSubmit, valid }) {
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return handleSubmit(
                                      _setup.changeEmailAddress
                                    )
                                  },
                                },
                              },
                              [
                                _c(_setup.ValidationProvider, {
                                  attrs: {
                                    rules: "email|required",
                                    name: "Email",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ valid, errors }) {
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass: "my-3",
                                                attrs: {
                                                  id: "new-email-input",
                                                  "label-cols": "3",
                                                  "content-cols": "9",
                                                  label: "New email",
                                                  "label-for":
                                                    "new-email-input",
                                                  "invalid-feedback": _setup.emailsAreTheSame
                                                    ? "New email must be different"
                                                    : _setup.invalidEmail
                                                    ? "Email already in use"
                                                    : errors[0],
                                                  state:
                                                    _setup.invalidEmail ||
                                                    _setup.emailsAreTheSame
                                                      ? false
                                                      : errors[0]
                                                      ? false
                                                      : valid
                                                      ? true
                                                      : null,
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "new-email-input",
                                                    type: "email",
                                                    state:
                                                      _setup.invalidEmail ||
                                                      _setup.emailsAreTheSame
                                                        ? false
                                                        : errors[0]
                                                        ? false
                                                        : valid
                                                        ? true
                                                        : null,
                                                    disabled:
                                                      _setup.savingEmail,
                                                    trim: "",
                                                  },
                                                  model: {
                                                    value: _setup.newEmail,
                                                    callback: function ($$v) {
                                                      _setup.newEmail = $$v
                                                    },
                                                    expression: "newEmail",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c(_setup.ValidationProvider, {
                                  attrs: {
                                    rules: "required|min:8",
                                    name: "Password",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ valid, errors }) {
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass: "my-3",
                                                attrs: {
                                                  id: "current-password-input",
                                                  "label-cols": "3",
                                                  "content-cols": "9",
                                                  label: "Current password",
                                                  "label-for":
                                                    "current-password-input",
                                                  "invalid-feedback": _setup.invalidPassword
                                                    ? "Wrong password"
                                                    : errors[0],
                                                  state: _setup.invalidPassword
                                                    ? false
                                                    : errors[0]
                                                    ? false
                                                    : valid
                                                    ? true
                                                    : null,
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id:
                                                      "current-password-input",
                                                    type: "password",
                                                    state: _setup.invalidPassword
                                                      ? false
                                                      : errors[0]
                                                      ? false
                                                      : valid
                                                      ? true
                                                      : null,
                                                    disabled:
                                                      _setup.savingEmail,
                                                  },
                                                  model: {
                                                    value:
                                                      _setup.currentPassword,
                                                    callback: function ($$v) {
                                                      _setup.currentPassword = $$v
                                                    },
                                                    expression:
                                                      "currentPassword",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "error-message w-100 pb-3 text-center",
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_setup.emailErrorMessage) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "modal-footer row pb-0" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          type: "reset",
                                          disabled: _setup.savingEmail,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return cancel()
                                          },
                                        },
                                      },
                                      [_vm._v(" Cancel ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      _setup.LoaderBtn,
                                      {
                                        attrs: {
                                          variant: "primary",
                                          type: "submit",
                                          "loading-text": "Saving",
                                          loading: _setup.savingEmail,
                                          disabled:
                                            !valid ||
                                            _setup.emailsAreTheSame ||
                                            _setup.savingEmail,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Change email address\n                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _setup.emailChanged,
                    expression: "emailChanged",
                  },
                ],
                staticClass:
                  "align-items-center confirmation-message justify-content-center",
              },
              [
                _c("div", [
                  _vm._v("\n                A confirmation email was sent to "),
                  _c("b", [_vm._v(_vm._s(_setup.newEmail))]),
                  _vm._v(
                    ". Please check your inbox and confirm your new email.\n            "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _setup.emailChanged,
                    expression: "emailChanged",
                  },
                ],
                staticClass: "modal-footer row pb-0",
              },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        return ok()
                      },
                    },
                  },
                  [_vm._v(" Ok ")]
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
    model: {
      value: _setup.isVisible,
      callback: function ($$v) {
        _setup.isVisible = $$v
      },
      expression: "isVisible",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }